import React, { useState, useEffect } from "react";
import AlertSuccess from "../componets/AlerSuccess";
import AlertError from "../componets/AlertError";
import { useWindowSize } from "../componets/useWindowSize";

import {
  getUserId,
  getUserDisplayName,
  saveUserGameInfo,
  clearUserGameInfo,
  logHistorico,
  getServerTime,
  addToPresenca,
  saveAppVersion,
} from "../data/userService";

import {
  getButtonCollapsedMemory,
  getHorarioInscricao,
  getLimitePresenca,
  getMenuCollapsedMemory,
  getSegunda,
  getVersionApp,
  setButtonCollapsedmemory,
  setMenuCollapsedmemory,
} from "../data/memory";

import { getDatabase, ref, onValue } from "firebase/database";
import { FaCakeCandles } from "react-icons/fa6";
import { autoResetJogosMensal } from "../data/autoClear";
import { resetList } from "../data/resetList";
import AlertPerigo from "../componets/AlertPerigo";
import WeatherBadge from "../componets/WeatherBadge";
import AppShell from "../componets/AppShell";

interface AttendanceData {
  uid: string;
  order: number;
  name: string;
  time: string;
  rawTime: number;
  numberOfGames: number;
  isBirthday: boolean;
  isTuesday: boolean;
}

const Dashboard: React.FC = () => {
  const { width } = useWindowSize();
  const [attendanceList, setAttendanceList] = useState<AttendanceData[]>([]);
  const [currentUserName, setCurrentUserName] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [isMensalModalOpen, setIsMensalModalOpen] = useState(false);
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );

  const [successAlert, setSuccessAlert] = useState<{
    open: boolean;
    message: string;
  }>({
    open: false,
    message: "",
  });

  const [errorAlert, setErrorAlert] = useState<{
    open: boolean;
    message: string;
  }>({
    open: false,
    message: "",
  });

  const showError = (msg: string) => {
    setErrorAlert({ open: true, message: msg });
    setTimeout(() => {
      setErrorAlert({ open: false, message: "" });
    }, 4500);
  };

  const [currentTime, setCurrentTime] = useState<string>("");

  useEffect(() => {
    resetList();
    saveAppVersion();
    autoResetJogosMensal();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const formatted = now.toLocaleTimeString("pt-BR", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      setCurrentTime(formatted);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else if (!getButtonCollapsedMemory()) {
      setIsMenuCollapsed(false);
      setMenuCollapsedmemory(false);
    }
  }, [width]);

  const handleMenuToggle = () => {
    const newButtonCollapsed = !isButtonCollapsed;
    const newMenuCollapsed = !isMenuCollapsed;
    setIsButtonCollapsed(newButtonCollapsed);
    setButtonCollapsedmemory(newButtonCollapsed);
    setIsMenuCollapsed(newMenuCollapsed);
    setMenuCollapsedmemory(newMenuCollapsed);
  };

  useEffect(() => {
    const init = async () => {
      const id = getUserId();
      const name = await getUserDisplayName();
      setUserId(id);
      setCurrentUserName(name);
    };

    init();

    const db = getDatabase();
    const usersRef = ref(db, "users");
    const unsubscribe = onValue(usersRef, async () => {
      await fetchAttendanceList();
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const init = async () => {
      setUserId(getUserId());
      setCurrentUserName(await getUserDisplayName());
    };
    init();

    const db = getDatabase();
    const usersRef = ref(db, "users");
    const unsubscribe = onValue(usersRef, fetchAttendanceList);
    return () => unsubscribe();
  }, []);

  const fetchAttendanceList = async () => {
    const db = getDatabase();
    const presencaRef = ref(db, "presenca");

    onValue(presencaRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setAttendanceList([]);
        return;
      }

      const entries: AttendanceData[] = Object.entries(data).map(
        ([uid, entry]: [string, any]) => {
          const inscricaoDate = new Date(entry.timestamp);

          return {
            uid,
            order: 0,
            name: entry.displayName || "Usuário",
            time: formatTimestamp(entry.timestamp),
            rawTime: inscricaoDate.getTime(),
            numberOfGames: entry.totalJogos || 0,
            isBirthday: entry.aniversario
              ? new Date(entry.aniversario).getMonth() === new Date().getMonth()
              : false,
            isTuesday: entry.isTuesday || false,
          };
        }
      );

      const segundaFeira = entries.filter((e) => !e.isTuesday);
      const tercaFeira = entries.filter((e) => e.isTuesday);

      const ordenados = [
        ...segundaFeira.sort((a, b) => {
          if (a.numberOfGames !== b.numberOfGames) {
            return a.numberOfGames - b.numberOfGames;
          }
          return a.rawTime - b.rawTime;
        }),
        ...tercaFeira.sort((a, b) => a.rawTime - b.rawTime),
      ].map((entry, index) => ({
        ...entry,
        order: index + 1,
      }));

      setAttendanceList(ordenados);
    });
  };

  const formatTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);
    return (
      date.toLocaleTimeString("pt-BR", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }) + `.${date.getMilliseconds()}`
    );
  };

  const isUserSubscribed = attendanceList.some((entry) => entry.uid === userId);

  const showSuccess = (msg: string) => {
    setSuccessAlert({ open: true, message: msg });
    setTimeout(() => {
      setSuccessAlert({ open: false, message: "" });
    }, 2000);
  };

  const handleSubscribe = async () => {
    try {
      let timestamp;
      try {
        timestamp = await getServerTime();
        if (!timestamp || isNaN(timestamp)) {
          throw new Error("Timestamp inválido do servidor");
        }
      } catch (error) {
        console.warn("⚠️ Falha ao obter hora do servidor, usando hora local.");
        timestamp = Date.now(); // fallback
      }

      const serverDate = new Date(timestamp);
      if (isNaN(serverDate.getTime())) {
        showError("Erro ao processar data/hora. Tente novamente.");
        return;
      }

      const day = serverDate.getDay();
      const hours = serverDate.getHours();
      const minutes = serverDate.getMinutes();

      const isMonday = day === getSegunda();
      const isTuesday = day === getSegunda() + 1;
      const isAfter13 =
        hours > getHorarioInscricao() ||
        (hours === getHorarioInscricao() && minutes >= 0);
      const isBeforeMidnight = hours < 24;
      const isBeforePlay = hours < 19;
      if (
        !(
          (isMonday && isAfter13 && isBeforeMidnight) ||
          (isTuesday && isBeforePlay)
        )
      ) {
        showError(
          `As inscrições só são permitidas na segunda-feira entre ${getHorarioInscricao()}:00 e 23:59 ou na terça-feira até 19:00.`
        );

        return;
      }

      if (!userId || !currentUserName) {
        showError("Usuário não encontrado.");
        return;
      }
      // 🔥 Pega o total de jogos atual no Firebase
      const db = getDatabase();
      const userRef = ref(db, `users/${userId}`);
      let currentTotal = 0;
      let jaContabilizado = false;
      let aniversario = "";
      let penalidadeJogo = false;

      const snapshot = await new Promise<any>((resolve) =>
        onValue(userRef, resolve, { onlyOnce: true })
      );

      if (snapshot.exists()) {
        const data = snapshot.val();
        currentTotal = data.totalJogos || 0;
        jaContabilizado = data.jogoContabilizado === true;
        aniversario = data.aniversario || "";
        penalidadeJogo = data.penalidadeJogo === true;
      }

      const newTotal = jaContabilizado
        ? currentTotal
        : penalidadeJogo
        ? currentTotal
        : currentTotal + 1;

      await saveUserGameInfo(
        userId,
        newTotal,
        jaContabilizado ? false : isTuesday,
        true
      ); // Marcar se foi na terça
      await addToPresenca(
        userId,
        currentUserName,
        isTuesday,
        newTotal,
        aniversario
      );
      await logHistorico("inscricao", userId, currentUserName, newTotal);
      showSuccess("Inscrição realizada com sucesso!");
    } catch (err) {
      console.error("Erro ao inscrever:", err);
      showError("Erro ao inscrever. Tente novamente.");
    }
  };
  const handleUnsubscribe = async () => {
    if (!userId || !currentUserName) return;

    try {
      const timestamp = await getServerTime();
      const serverDate = new Date(timestamp);

      const day = serverDate.getDay(); // 1 = Segunda, 2 = Terça
      const isMonday = day === getSegunda();
      const isTuesday = day === getSegunda() + 1;

      const db = getDatabase();
      const userRef = ref(db, `users/${userId}`);
      const snapshot = await new Promise<any>((resolve) => {
        onValue(userRef, (snap) => resolve(snap), { onlyOnce: true });
      });

      const userData = snapshot.val();
      const currentTotalJogos = userData?.totalJogos || 0;
      const userIsTuesday = userData?.isTuesday || false;
      const jogoContabilizado = userData?.jogoContabilizado || false;
      const penalidadeJogo = userData?.penalidadeJogo || false;

      console.log("🧪 isTuesday:", isTuesday);
      console.log("🧪 currentTotalJogos:", currentTotalJogos);
      console.log("🧪 userIsTuesday:", userIsTuesday);
      console.log("🧪 jogoContabilizado:", jogoContabilizado);
      console.log("🧪 penalidadeJogo:", penalidadeJogo);

      // ✅ Proteção contra tentativa de burlar penalidade
      if (penalidadeJogo === true) {
        console.log(
          "Usuário já penalizado anteriormente. Cancelamento sem alteração no total de jogos."
        );
        await saveUserGameInfo(userId, currentTotalJogos, false, false, true);
        showSuccess("Inscrição cancelada. Penalidade mantida.");
        await clearUserGameInfo(userId);
        await logHistorico("cancelamento", userId, currentUserName);
        return;
      }

      // 🔵 Segunda-feira: se inscreveu e cancelou no mesmo dia
      if (
        isMonday &&
        currentTotalJogos > 0 &&
        jogoContabilizado &&
        !penalidadeJogo
      ) {
        console.log("Se inscreveu segunda e cancelou segunda");
        await saveUserGameInfo(
          userId,
          currentTotalJogos - 1,
          false,
          false,
          false
        );
        showSuccess("Inscrição cancelada e jogo removido.");
      }

      // 🔵 Terça-feira: se inscreveu e cancelou na própria terça
      else if (
        isTuesday &&
        currentTotalJogos > 0 &&
        userIsTuesday === true &&
        jogoContabilizado === true
      ) {
        // Se já sofreu penalidade antes, não contabiliza novo jogo
        if (userData.penalidadeJogo === true) {
          console.log("Se inscreveu terca e cancelou terca");
          await saveUserGameInfo(userId, currentTotalJogos, false, false, true);
          showSuccess("Inscrição cancelada e jogo removido.");
        } else {
          console.log("Se inscreveu terca e cancelou terca");
          await saveUserGameInfo(
            userId,
            currentTotalJogos - 1,
            false,
            false,
            false
          );
          showSuccess("Inscrição cancelada e jogo removido.");
        }
      }

      // 🔴 Cancelou na terça mas se inscreveu na segunda
      else if (
        isTuesday &&
        currentTotalJogos > 0 &&
        userIsTuesday === false &&
        jogoContabilizado === true
      ) {
        const userIndex = attendanceList.findIndex(
          (entry) => entry.uid === userId
        );
        console.log("ranking: " + userIndex);

        if (userIndex >= 0 && userIndex < getLimitePresenca()) {
          console.log(`Está no top ${getLimitePresenca()}`);
          await saveUserGameInfo(userId, currentTotalJogos, false, true, true);
          showSuccess("Inscrição cancelada porém jogo contabilizado.");
        } else {
          console.log("Está na lista de espera");
          await saveUserGameInfo(
            userId,
            currentTotalJogos - 1,
            false,
            false,
            false
          );
          showSuccess("Inscrição cancelada e jogo removido.");
        }
      }

      await clearUserGameInfo(userId);
      await logHistorico("cancelamento", userId, currentUserName);
    } catch (err) {
      console.error("Erro ao cancelar inscrição:", err);
      showError("Erro ao cancelar inscrição.");
    }
  };

  const handleCancelClick = () => {
    setIsMensalModalOpen(true);
  };

  return (
    <>
      <AlertSuccess
        isOpen={successAlert.open}
        message={successAlert.message}
        onClose={() => setSuccessAlert({ open: false, message: "" })}
      />

      <AlertError
        isOpen={errorAlert.open}
        message={errorAlert.message}
        onClose={() => setErrorAlert({ open: false, message: "" })}
      />

      <AlertPerigo
        isOpen={isMensalModalOpen}
        onClose={() => setIsMensalModalOpen(false)}
        onConfirm={() => {
          handleUnsubscribe();
          setIsMensalModalOpen(false);
        }}
        message="Você tem certeza que deseja cancelar sua inscrição?"
      />
      <AppShell
        isMenuCollapsed={isMenuCollapsed}
        onToggleMenu={handleMenuToggle}
      >
        <section className="panel-glass rounded-[2rem] p-4 sm:p-8">
          <div className="mb-6 sm:mb-8 flex items-center justify-between gap-3">
            <h2 className="text-base font-semibold sm:text-xl md:text-2xl">
              Lista para o play
            </h2>
            <WeatherBadge />
          </div>

          <div className="mb-6 flex flex-col sm:flex-row sm:justify-between gap-2">
            {isUserSubscribed ? (
              <button
                onClick={handleCancelClick}
                className="w-full rounded-2xl border border-white/10 bg-white/10 px-4 py-3 text-sm font-medium text-white transition hover:bg-white/14 sm:w-auto"
              >
                Cancelar inscrição
              </button>
            ) : (
              <button
                onClick={handleSubscribe}
                className="w-full rounded-2xl bg-gradient-to-r from-pink-500 to-rose-500 px-4 py-3 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(244,114,182,0.28)] transition hover:brightness-105 sm:w-auto"
              >
                Inscrever
              </button>
            )}
          </div>

          <div className="panel-soft custom-scrollbar overflow-x-auto rounded-[1.5rem]">
            <table className="min-w-full text-xs sm:text-sm table-fixed">
              <thead>
                <tr className="text-left border-b border-white/10 text-zinc-300">
                  <th className="w-10 px-1 sm:px-4 py-2">Ordem</th>
                  <th className="px-1 sm:px-4 py-2">Nome</th>
                  <th className="w-20 px-1 sm:px-4 py-2">Horário</th>
                  <th className="w-16 px-1 sm:px-4 py-2 text-right">
                    <span className="block sm:hidden">Nº Jogos</span>
                    <span className="hidden sm:block">Nº de Jogos</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {attendanceList.map((attendance, index) => (
                  <tr
                    key={attendance.order}
                    className={`border-b border-white/8 transition hover:bg-white/6 ${
                      index >= getLimitePresenca() ? "text-rose-300" : ""
                    }`}
                  >
                    <td className="w-10 px-1 sm:px-4 py-2">
                      {attendance.order}
                    </td>
                    <td className="px-1 sm:px-4 py-2 max-w-[140px]">
                      <span className="flex items-center gap-2">
                        {attendance.isBirthday && (
                          <FaCakeCandles className="text-rose-300 text-sm flex-shrink-0" />
                        )}
                        <span className="truncate block max-w-[150px]">
                          {attendance.name}
                        </span>
                      </span>
                    </td>

                    <td className="w-20 px-1 sm:px-4 py-2 truncate">
                      {attendance.time}
                    </td>
                    <td className="w-16 px-1 sm:px-4 py-2 text-right">
                      {attendance.numberOfGames}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4 w-full text-center text-xs text-zinc-400 sm:text-sm">
            Hora atual: {currentTime}
          </div>
        </section>

        <div className="w-full py-2 text-center">
          <span className="text-xs text-zinc-500 sm:text-sm">
            Developed by Samuel Stork
          </span>{" "}
          <span className="text-xs text-zinc-600 sm:text-sm">
            {getVersionApp()}
          </span>
        </div>
      </AppShell>
    </>
  );
};

export default Dashboard;
